import { campaignTypes } from "@campaign/campaign-types.di";
import type { CampaignRepository } from "@campaign/domain/repositories/campaign.repository";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import type { Id } from "@core/domain/value-objects/id.value-object.ts";
import { inject, injectable } from "inversify";

@injectable()
export class CampaignDeleteUseCase {
    constructor(
        @inject(campaignTypes.repositories.CampaignRepository)
        private readonly campaignRepository: CampaignRepository,
    ) {}
    async execute(campaignId: Id): Promise<boolean> {
        const result = await this.campaignRepository.delete(campaignId.value);

        if (result.isErr()) {
            ToastManagerRepository.error(result.error.message);
        }

        return result.isOk();
    }
}
